'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');

const NonAuthenticatedFeatures=[
'fdc.features.login'];let


StateChangeDirective=class StateChangeDirective{
static get type(){
return'directive';
}

factory($rootScope,$state,$modalStack,userService,errorHandlers){
let stateAuthenticator=new StateAuthenticator(NonAuthenticatedFeatures,$state,$modalStack,userService,errorHandlers);
return{
restrict:'A',
link:scope=>{
$rootScope.$on('$stateChangeStart',function(){
stateAuthenticator.process(..._.toArray(arguments));
});
}};

}

static get StateAuthenticator(){
return StateAuthenticator;
}};


StateChangeDirective.prototype.factory.$inject=['$rootScope','$state','$modalStack','userService','errorHandlers'];let

StateAuthenticator=class StateAuthenticator{
constructor(nonAuthenticatedFeatures,$state,$modalStack,userService,errorHandlers){
this._nonAuthenticatedFeatures=nonAuthenticatedFeatures;
this._$state=$state;
this._$modalStack=$modalStack;
this._userService=userService;
this._errorHandlers=errorHandlers;
}

process(event,toState,toParams={},fromState,fromParams){
this._mostRecentlyProcessedState=toState;
this._mostRecentlyProcessedParams=toParams;

if(!this._requiresAuthentication(toState)||this._hasBeenAuthenticated(toParams)){
let top=this._$modalStack.getTop();

if(_.exists(top)){
if(this._requiresAuthentication(toState)&&this._hasBeenAuthenticated(toParams)||fromState.name!==this._loginFeatureName){

this._$modalStack.dismiss(top.key);
}else if(!this._hasBeenAuthenticated(toParams)&&toState.name===this._loginFeatureName){


this._$modalStack.dismiss(top.key);
}
}
return;
}

event.preventDefault();

this._tryToContinueToAuthenticatedState();
}

_requiresAuthentication(state){
return!_(this._nonAuthenticatedFeatures).includes(state.name);
}

_hasBeenAuthenticated(params){
return _.exists(params.authenticated)&&params.authenticated===!0;
}

async _tryToContinueToAuthenticatedState(){
let error=void 0;
let errorHandler=void 0;
try{
await this._userService.continueUserSession();
}catch(e){
errorHandler=this._errorHandlers.handlerFor(e);
if(!_.exists(errorHandler)){
throw e;
}
error=e;
}

if(!this._requiresAuthentication(this._mostRecentlyProcessedState)){
return;
}

if(_.exists(errorHandler)){
errorHandler(error);
return;
}

this._mostRecentlyProcessedParams.authenticated=!0;
this._$state.go(this._mostRecentlyProcessedState.name,this._mostRecentlyProcessedParams);
}

get _loginFeatureName(){
return this._nonAuthenticatedFeatures[0];
}};


module.exports=StateChangeDirective;
//# sourceMappingURL=stateChangeDirective.js.map
